export default __webpack_public_path__ + "static/Graph2-eab2027cd240391f8f1d6718fb2bc399.webp";